import { render, staticRenderFns } from "./modalNotasTrabajoSocialCreate.vue?vue&type=template&id=24ba5e0d"
import script from "./modalNotasTrabajoSocialCreate.vue?vue&type=script&lang=js"
export * from "./modalNotasTrabajoSocialCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports